import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { NgxsModule } from "@ngxs/store";
import { CaseState } from "./state+/case.state";

@NgModule({
  imports: [CommonModule, NgxsModule.forFeature([CaseState])]
})
export class CaseStateModule {}
